// Component 내부 함수의 this에 자기 Component를 auto bind 하기 위함

import {filter} from "ramda";
import {Component} from "react";

const getAllMethods = (obj) => {
  return filter(key => typeof obj[key] === "function", Object.getOwnPropertyNames(obj));
}

const autoBind = (obj) => {
  getAllMethods(obj.constructor.prototype)
    .forEach(mtd => {
      obj[mtd] = obj[mtd].bind(obj);
    });
}

export default class AutoBindComponent extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
}



// WEBPACK FOOTER //
// ./src/Component.js